import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { Activity } from 'react';

import ZIP_OPTIONS from '../../data/zipCodes.json';
import DiagnosisCodes from './DiagnosisCodes';

const PROVIDER_OPTIONS_EXTENDED = [
  'Achieve Behavioral Health',
  'Arms Acres',
  'Astor Services',
  'Catholic Charities',
  'CHOICE of NY',
  'Cove Care Center',
  'Family Services (Non-Westchester)',
  'Family Services of Westchester',
  'HONORegh',
  'Human Development Services of Westchester',
  'Independent Living',
  'Innovative Health Systems',
  'Mental Health America of Dutchess County',
  'Mental Health Association of Orange County',
  'Mental Health Association of Ulster',
  'Regional Economic Community Action Program',
  'Rehabilitation Support Services',
  'Restorative Management Corp',
  'Search for Change',
  `St. Christopher's Inn`,
  'The Guidance Center of Westchester',
  'Westchester Jewish Community Services',
];

const PROVIDER_OPTIONS = [
  '',
  'Access: Supports for Living',
  'Greater Mental Health NY',
  'Lexington Center for Recovery',
];
const INSURANCE_OPTIONS = [
  'MVP',
  'Fidelis',
  'UnitedHealthCare',
  'Molina HealthCare',
  'HealthFirst',
  'Partners Health Plan',
  'Aetna',
  'Medicaid',
  'Managed Medicaid',
  'Medicare',
  'Blue Cross Blue Shield',
  'Carelon',
  'Uninsured',
  'Other',
];
const LANGUAGE_OPTIONS = ['English', 'Spanish', 'German', 'Chinese', 'French'];

export default function SelectOptions({
  existingClinic,
  setExistingClinic,
  alertZIP,
  setAlertZIP,
  insuranceProvider,
  setInsuranceProvider,
  otherInsuranceOption,
  setOtherInsuranceOption,
  preferredLanguage,
  setPreferredLanguage,
  diagnosisCode,
  setDiagnosisCode,
  secondDiagnosisCode,
  setSecondDiagnosisCode,
  isCO,
}) {
  const shouldShowSecondDiagnosisCode = isCO && diagnosisCode !== '';
  const isOtherInsuranceError =
    insuranceProvider === 'Other' && !otherInsuranceOption;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        minWidth: '120px',
      }}
    >
      <FormControl fullWidth>
        <InputLabel id='existing-provider-label'>
          Existing Provider/Clinic
        </InputLabel>
        <Select
          labelId='existing-provider-label'
          id='existing-provider'
          value={existingClinic}
          label='Existing Provider'
          onChange={(e) => setExistingClinic(e.target.value)}
        >
          {PROVIDER_OPTIONS.map((option) => (
            <MenuItem
              key={option}
              value={option}
            >
              {!option ? <em>None</em> : option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl
        error={!insuranceProvider}
        required
      >
        <InputLabel id='insurance-label'>Insurance</InputLabel>
        <Select
          labelId='insurance-label'
          id='insurance'
          value={insuranceProvider}
          label='Insurance'
          onChange={(e) => setInsuranceProvider(e.target.value)}
        >
          {INSURANCE_OPTIONS.map((option) => (
            <MenuItem
              key={option}
              value={option}
            >
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {insuranceProvider === 'Other' && (
        <TextField
          required={insuranceProvider === 'Other'}
          error={isOtherInsuranceError}
          label='Other Insurance Provider'
          variant='outlined'
          value={otherInsuranceOption}
          onChange={(e) => setOtherInsuranceOption(e.target.value)}
        />
      )}
      <DiagnosisCodes
        label='Diagnosis Code'
        setDiagnosisCode={setDiagnosisCode}
      />
      <Activity mode={shouldShowSecondDiagnosisCode ? 'visible' : 'hidden'}>
        <DiagnosisCodes
          label={'2nd Diagnosis Code'}
          setDiagnosisCode={setSecondDiagnosisCode}
        />
      </Activity>
      <FormControl>
        <Autocomplete
          value={alertZIP}
          options={ZIP_OPTIONS}
          onChange={(event, newValue, reason) => {
            if (reason === 'clear') {
              setAlertZIP('');
              return;
            }
            setAlertZIP(newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              required
              error={!alertZIP}
              label='Patient ZIP Code'
            />
          )}
        />
      </FormControl>
      <FormControl>
        <InputLabel id='language-label'>Preferred Language</InputLabel>
        <Select
          labelId='language-label'
          id='language'
          value={preferredLanguage}
          label='Language'
          onChange={(e) => setPreferredLanguage(e.target.value)}
        >
          {LANGUAGE_OPTIONS.map((option) => (
            <MenuItem
              key={option}
              value={option}
            >
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
